<template>
  <div class="evaluate-and-connect">
    <div class="evaluate" @click="handleEvaluate">
      <svgicon class="icon-evaluate" name="icon-evaluate"></svgicon>
      <span>满意度评价</span>
    </div>
    <div class="line"></div>
    <div class="connect" @click="handleConnect">
      <svgicon class="icon-evaluate" name="connect"></svgicon>
      <span>咨询客服</span>
    </div>
  </div>
</template>

<script>
//重连-评价model

import evaluateAndConnect from "src/mixins/evaluateAndConnect";
export default {
  name: "reconnect-model",
  mixins: [evaluateAndConnect],
  computed: {
    ...mapState(["mainColor"])
  }
};
</script>

<style lang="less" scoped>
.evaluate-and-connect {
  display: flex;
  align-items: center;
  background-color: #fff;
  border-top: 1px solid #eaeaea;
  .evaluate,
  .connect {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    text-align: center;
    cursor: pointer;
    span {
      display: inline-block;
      width: 100%;
    }
    .icon-evaluate {
      width: 60px;
      height: 60px;
      fill: var(--header-bg) !important;
    }
  }
}
.pc {
  .evaluate-and-connect {
    height: 120px;
    .evaluate,
    .connect {
      flex: 1;
      height: 70px;

      &:hover {
        opacity: 0.5;
      }

      span {
        font-size: 14px;
        color: var(--evaluate-finished-text);
        &:active {
          color: var(--evaluate-finished-text-click);
        }
      }
    }

    .line {
      width: 1px;
      height: 70px;
      background-color: #eaeaea;
    }
  }
}
</style>
